import { createTheme } from "@mui/material";
import { PRIMARY_COLOR, SECONDARY_COLOR } from "../_const/color.const";


export const theme = createTheme({
    typography: {
        fontFamily: 'Futura',
        h1: {
            fontSize: '3rem',
            [createTheme().breakpoints.up('sm')]: {
                fontSize: '3.5rem',
            },
            [createTheme().breakpoints.up('sm')]: {
                fontSize: '4rem',
            },
        },
        h2: {
            fontSize: '2.2rem',
            [createTheme().breakpoints.up('sm')]: {
                fontSize: '3rem',
            },
            [createTheme().breakpoints.up('sm')]: {
                fontSize: '3.5rem',
            },
        },
        h3: {
            fontSize: '2rem',
            [createTheme().breakpoints.up('sm')]: {
                fontSize: '2.25rem',
            },
            [createTheme().breakpoints.up('sm')]: {
                fontSize: '2.5rem',
            },
        },
        h4: {
            fontSize: '1.45rem',
            [createTheme().breakpoints.up('sm')]: {
                fontSize: '2rem',
            },
        },
        h5: {
            fontSize: '1rem',
            [createTheme().breakpoints.up('sm')]: {
                fontSize: '20px',
            },
            [createTheme().breakpoints.up('md')]: {
                fontSize: '26px', 
            },
        },
        h6: {
            fontSize: '1.25rem',
            [createTheme().breakpoints.up('sm')]: {
                fontSize: '1.5rem',
            },
        },
        body1: {
            fontSize: '14px',
            [createTheme().breakpoints.up('sm')]: {
                fontSize: '1.125rem',
            },
        },
        body2: {
            fontSize: '0.775rem',
            [createTheme().breakpoints.up('sm')]: {
                fontSize: '0.8rem',
            },
        },
        subtitle1: {
            fontSize: '14px',
            [createTheme().breakpoints.up('sm')]: {
                fontSize: '1.3rem',
            },
        },
        subtitle2: {
            fontSize: '12px',
            [createTheme().breakpoints.up('sm')]: {
                fontSize: '1rem',
            },
        },
    },
    palette: {
        primary: {
            main: PRIMARY_COLOR,
        },
        secondary: {
            main: SECONDARY_COLOR
        }
    },
    components: {
        MuiAlert: {
            styleOverrides: {
                root: {
                    fontSize: '1rem',
                },
                message: {
                    fontSize: '1rem',
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    padding: '8px',
                    backgroundColor: '#f6f6f6',
                    //boxShadow: "0 4px 12px rgba(0, 0, 0, 0.06)",
                    borderRadius: '4px',
                    [createTheme().breakpoints.up('sm')]: {
                        padding: '16px',
                    
                    }
                },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: '0px !important'
                },
            },
        },
        MuiMenu: { // dropdown - SelectValidator
            styleOverrides: {
                paper: {
                    maxHeight: 200,
                    overflowY: "auto"
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    boxShadow: 'none'
                }
            },
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    fontSize: '1.2rem',
                    '@media (max-width:600px)': {
                        fontSize: '0.9rem', 
                    },
                    '&.Mui-selected': {
                        backgroundColor: '#f91eaf',
                        color: '#fff',
                        '&:hover': {
                            backgroundColor: '#f91eaf',
                        },
                    },
                },               
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    boxShadow: 'none',
                    borderRadius: '4px',
                    fontSize: '12px',
                    width: "150px",
                    padding: 2,
                    margin: '0 auto',
                    [createTheme().breakpoints.up('sm')]: {
                        fontSize: '1.1rem',
                        width: "200px",
                        padding: 1
                    },
                    [createTheme().breakpoints.up('md')]: {
                        fontSize: '1.2rem',
                        width: "200px",
                        padding: 2
                    },
                    [createTheme().breakpoints.up('lg')]: {
                        fontSize: '1.3rem',
                        width: "200px",
                        padding: 2
                    },
                },
                contained: {
                    backgroundColor: PRIMARY_COLOR,
                },
                outlined: {
                    borderColor: PRIMARY_COLOR,
                },
            },
        },
        MuiCheckbox: {
            styleOverrides: {
                root: {
                    transform: "scale(1.5)"
                },
            },
        },
        MuiTextField: {
            styleOverrides: {
                root: {
                    '& .MuiInputBase-root': {
                        borderRadius: '4px',
                        fontSize: '18px'
                    },
                }
            }
        },    
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    fontSize: "1.2rem",
                    "&.Mui-error": {
                        "fontSize": "1.2rem",
                        "color": "red"
                    }
                },
                //error: {
                //    fontSize: "1.2rem", 
                //    color: "red"
                //},
            },
        },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    color: PRIMARY_COLOR,
                    fontSize: '1.2rem !important',
                    marginBottom: '8px',
                //    marginLeft: '8px'
                },
                asterisk: {
                    color: 'red',
                },
            },
        },
        MuiSlider: {
            styleOverrides: {
                root: {
                    color: PRIMARY_COLOR,
                    height: 6,
                    fontSize: '8px',
                    width: '100%',
                    paddingBottom: '10px !important'
                },
                thumb: {
                    width: 16, 
                    height: 16, 
                    borderRadius: '4px',
                    //backgroundColor: 'transparent', 
                    //boxShadow: '0 1px 2px rgba(0, 0, 0, 0.2)',
                    border: '1px solid #ccc', 
                },
                track: {
                    border: 'none'
                },
                rail: {
                    opacity: 0.2,
                },
                mark: {
                    display: 'none'
                },
                markLabel: {
                    color: 'grey',
                    fontSize: '0.70rem',
                },
                
            },

        },
         
       
    },


});